import styled from 'styled-components'
import { BREAKPOINTS } from 'styles/constants'

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 25px;
  button {
    max-width: 150px;

    &:not(:last-child) {
      margin-right: 15px;
    }
  }
`

export const NotificationLink = styled.span`
  color: var(--p-blue-300);
`

export const FieldGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 16px;
  & > div,
  label {
    flex: 0 0 calc((100% - ${(p) => (p.count - 1) * 15}px) / ${(p) => p.count});
    min-width: 0;
    @media (max-width: ${BREAKPOINTS.mobile}) {
      width: 100%;
      flex: 0 0 100%;
    }
  }
  && > * {
    margin-bottom: 0;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    margin-bottom: 10px;
  }
`

export const UploaderContainer = styled.div`
  margin-bottom: 20px;
`

export const SelectWithCheckboxesWrap = styled.div`
  /* margin-bottom: 28px; */
`

export const DateGroup = styled.div`
  display: flex;
  margin-bottom: 28px;

  &:not(:last-child) {
    margin-right: 15px;
  }
`

export const DateItem = styled.div`
  & label {
    width: 100%;
  }

  &:not(:last-child) {
    margin-right: 15px;
  }

  .react-datepicker__close-icon {
    display: none;
  }
`
